export default {
  common: {
    noData: "No Data",
    noSearchData: "No search results",
    resend: "Resend",
    confirm: "Confirm",
    cancel: "Cancel",
    sort: "Sort",
    createdAt: "Create time",
    updatedAt: "Modify time",
    name: "Name",
    nickName: "Nickname",
    size: "Size",
    type: "Type",
    source: "Source",
    endTime: "Expiry Date",
    handle: "Operating",
    fileList: "File list",
    model: "Model",
    customerService: "Customer Service",
    send: "Send",
    save: "Save",
    modify: "Modify",
    phone: "Phone",
    email: "Email",
    code: "Verification Code",
    wechat: "WeChat",
    image: "Pictures",
    audio: "Audio",
    folder: "Folders",
    note: "Notes",
    prompt: "Prompt",
    copy: "Copy",
    sms: "SMS",
    password: "Password",
    oldVersion: "Old",
    newVersion: "New",
    upload: "Upload",
    downloading: "downloading...",
    uploading: "Uploading...",
    check: "查询",
  },

  router: {},

  tooltip: {},

  placeholder: {
    phone: "Please enter Mobile number",
    email: "Please enter E-mail",
    code: "Please enter Verification Code",
    name: "Please enter name",
    website: "Please enter the URL",
    img: "Select an image",
    search: "Please enter search content",
    content: "Please enter content",
  },

  alert: {},

  elMsg: {
    phoneEmpty: "The Mobile number can not be empty or contains any space. ",
    areaEmpty: "Area code cannot be empty",
    emailEmpty: "E-mail can not be empty or contains any space",
    codeEmpty: "Verification Code can not be empty or contains any space. ",
    contentEmpty: "You can not send empty message. ",
    nameEmpty: "Name can not be empty. ",
    nameSame: "In this folder, you already have a notepad with the same name. ",
    emailError: "Incorrect E-mail format",
    max80: "No more than 80 characters",
    delSuccess: "Deleted successfully",
    delFailure: "Delete failed",
    copySuccess: "Copy successfully",
    copyFailure: "Copy failed",
    cancelSuccess: "Cancelled successfully",
    favoriteSuccess: "Add to Favorites successfully",
    restoreSuccess: "Resored successfully",
    pushSuccess: "Pushed successfully",
    createSuccess: "Created successfully",
    moveSuccess: "Moved successfully",
    unbindSuccess: "Unbind successfully",
    modifySuccess: "Modified successfully",
    bindSuccess: "Bind successfully",
    checkSuccess: "Search successful",
    getSuccess: "Received successfully",
    sendSuccess: "Sent successfully",
    selectFile: "Please tick files",
    tips1:
      "Your Cloud storage is not enough. Please try again after freeing up some space. ",
    tips2: "File size can not exceed 200M",
    tips3: "Please select the file you want to work on. ",
    tips4: "Please upload images in JPG, JPEG, or PNG format.",
    tips5: "Please enter valid URL. ",
    tips6: "Please select a folder. ",
    tips7: "Image size can not exceed 3M.",
    tips8: "Please select the images you want to upload. ",
    tips9: "Verification Code only supports numbers. ",
    tips10:
      "This Mobile number has already been bound to other user and cannot be bound again.",
    tips11: "Mobile number bound successfully",
    tips12:
      "This E-mail has already been bound to other user and cannot be bound again.",
    tips13: "E-mail bound successfully",
    tips14: "The login of this account has expired. Please log in again.",
    tips15: "The file size exceeds %{size}",
    tips16: "No binding device, please bind from device side",
    tips17:
      "This account already has a master account and cannot be associated",
    tips18: "Copy the code to the clipboard",
    tips19: "Please tick the audio that needs to be downloaded.",
    tips20: '如该号码收不到验证码，请与商家联系确定手机号'
  },

  login: {
    logout: "Sign Out",
    login: "Sign in",
    phoneLogin: "Sign in with Mobile nubmer",
    emailLogin: "Sign in with E-mail",
    scanLogin: "Scan code to sign in",
    scanTips1: "Open BOOX Assistant app",
    scanTips2: "Open [Scan] on the top of Account",
    scanTips3: "QR code expired. Please scan again. ",
    getCode: "Obtain Verification Code",
    agree: "Agree",
    privacy: "Privacy Policy",
    agreement: "User Agreement",
    autoLogin: "Remember Me",
  },
};
